import { useRouter } from '@tanstack/react-router';

export function useHistoryBack(onNoHistory: () => void): () => void {
  const router = useRouter();

  return () => {
    if (router.history.canGoBack()) {
      router.history.back();
      return;
    }
    onNoHistory();
  };
}
